module.exports = __webpack_public_path__ + "img/service1.019ec926.webp";